import { VariableType } from 'json-to-graphql-query';
import { EntityResource } from './entity.resource';
import { CollectionPointVariables, CollectionPointArgs } from './queryVariables/collectionPoint';
export class CollectionPointResource extends EntityResource {
    constructor() {
        super({ entityName: 'collectionPoint' });
        this.getFields = {
            id: true,
            state: true,
            name: true,
            description: true,
            woj: true,
            pow: true,
            gmi: true,
            terc: true,
            city: true,
            simc: true,
            street: true,
            homeNumber: true,
            localNumber: true,
            ulic: true,
            postalCode: true
        };
        this.listFields = {
            id: true,
            state: true,
            name: true,
            woj: true,
            pow: true,
            gmi: true,
            terc: true,
            city: true,
            simc: true,
            street: true,
            homeNumber: true,
            localNumber: true,
            ulic: true,
            postalCode: true
        };
        this.addVariables = CollectionPointVariables;
        this.addArgs = CollectionPointArgs;
        this.updateVariables = { id: 'Int!', ...CollectionPointVariables };
        this.updateArgs = { id: new VariableType('id'), ...CollectionPointArgs };
    }
}
export const collectionPointResource = new CollectionPointResource();
//# sourceMappingURL=collectionPoint.resource.js.map